'use es6';

import { combineReducers } from 'redux';
import Auth from './Auth';
import GettingStarted from './GettingStarted';
export default combineReducers({
  auth: Auth,
  gettingStarted: GettingStarted
});